module.exports = __webpack_public_path__ + "img/idcard.4da3d6fd.png";